<template>
    <div class="progress" :style="{ height: `${height}rem` }">
        <div class="progress_bar" :style="{ background: `${backgroundColor}` }">
            <div class="progress_rate" :style="{ width: `${progress}` + '%', height: `${height}rem` }"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'lineProgress',
    props: {
        height: {
            type: Number,
            default: 0.15
        },
        progress: {
            type: [Number, String],
            default: 0
        },
        backgroundColor: {
            type: String,
            default: 'rgba(255,255,255,.15)'
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss">
@import '@/common/styles/viriables.scss';
.progress {
    width: 100%;

    .progress_bar {
        width: 100%;
        height: 100%;
        border-radius: .2rem;
        position: relative;
        padding: .02rem;
        background: $bg-progress-color !important;
        overflow: hidden;
    }

    .progress_rate {
        position: absolute;
        top: 0;
        max-width: 100%;
        border-radius: .2rem;
        background: linear-gradient(141deg, #faebc5, #feaf5c 48%, #ebd5a8);
    }
}
</style>
